import type {
  ProductResponse,
  ProductsResponse,
} from "@/infrastructure/services/productService";
import type { Product, ProductStatus } from "./types";

const statusMap: Record<ProductResponse["status"], ProductStatus> = {
  PUBLICADO: "published",
  RASCUNHO: "draft",
  OCULTO: "hidden",
};

export function mapProduct(product: ProductResponse): Product {
  const date = new Date(product.updated_at);
  return {
    id: product.id,
    name: product.nome,
    keyword: product.palavras_chave.join(", ") || "—",
    keywords: product.palavras_chave,
    categoryId: String(product.categoria.id),
    category: product.categoria.nome,
    status: statusMap[product.status] ?? "draft",
    updatedAt: Number.isNaN(date.getTime())
      ? "—"
      : new Intl.DateTimeFormat("pt-BR").format(date),
  };
}

export function mapMetrics(data: ProductsResponse) {
  return {
    total: data.produtos_cadastrados,
    visible: data.visiveis_vitrine,
    unpublished: data.nao_publicados,
  };
}
